<template>
    <span class="resource-container" @click.prevent="resourceShow(data_resource)">
        <div style="display: flex; flex-direction: row; justify-content: space-between; padding-right: 20px">
            <div >
                <p class="item-resource-name">{{data_resource.name}}</p>
            </div>
            <div style="display: flex; flex-direction: row;align-items: center">
                <div v-if="check === true">
                    <clip-loader :color="color" :size="size"></clip-loader>
                </div>

                <div v-else>
                    <div v-if="this.data_resource.resource_person.length === 1">
                        <i class="fas fa-check-circle" style="color: #047B34; font-size: 1.3rem"></i>
                    </div>
                    <div v-else>
                        <i class="fas fa-play" style="color: #07CCD4"></i>
                    </div>

                </div>
            </div>
        </div>

    </span>
</template>
<script>
    import {mapState, mapGetters} from 'vuex'
    import axios from 'axios'
    import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
    import toastr from 'toastr'
    export default {
        name: 'resourceStore',
        components: {
            ClipLoader
        },
        props:['data_resource'],
        created(){

        },

        data(){
            return {
                check: false,
                color:'#7366E4',
                size:'20px',
                status:''
            }
        },
        computed: {
            ...mapState,
            ...mapGetters({
                today:'today',
                video_finish: 'course/video_finish'
            })

        },
        methods:{

            resourceShow:function (data_resource) {
                this.$store.commit('course/vimeo_Id', (data_resource.data.id_video));
                this.$store.commit('course/resource_id', (data_resource.id));
                this.$store.commit('course/lesson_Id', (data_resource.lessons_id));
                this.$store.commit('course/resource_type', (data_resource.type));
                this.$store.commit('Rdrawer', false);

            }
        },



    }
</script>
<style scoped>
    .resource-container{
        display: flex;;
        flex-direction: column;

    }
    .resource-container:hover{
        background: #F0F0F0;
    }
    .item-resource-name{
        width: 100%;
        display: flex;
        padding: 5px 5px;
        cursor: pointer;
        font-size: 1.2rem;


    }
    .item-resource-name:hover{
        color: #7465E4;
        font-weight: 400;
    }
</style>